<template>
  <folder-card :name="folder.name" :items-count="itemsCount">
    <template #actions>
      <share-folder-button
        v-if="!pickOnly && !folder?.folder_id && folder.editable"
        :is-shared="folder.shared_bookmarks?.length > 0"
        @share="$emit('shareFolder')"
      />

      <lesson-folder-controls
        v-if="!pickOnly"
        :folder="folder"
        @action="$emit($event)"
      />
    </template>
  </folder-card>
</template>

<script>
import LessonFolderControls from './LessonFolderControls.vue';
import FolderCard from '@/components/basic/folders/FolderCard.vue';
import ShareFolderButton from '@/components/basic/folders/ShareFolderButton.vue';

export default {
  name: 'LessonFolderCard',
  components: {
    LessonFolderControls,
    FolderCard,
    ShareFolderButton,
  },
  props: {
    folder: {
      type: Object,
      default: () => ({}),
    },
    pickOnly: {
      type: Boolean,
    },
  },
  computed: {
    itemsCount() {
      let { lessons_count = 0, folders_count = 0 } = this.folder;
      return lessons_count + folders_count;
    },
  },
};
</script>
